import Navbar from "react-bootstrap/Navbar";

import Logo from "../img/logo-simapp.png";

export default function NavbarLogo (props)
{
    return (
	<Navbar.Brand>
	    <img alt="Logo SIM'App" src={Logo} height="40" className="d-inline-block align-top mx-2"/>
	    {/* SIM'App */}
	</Navbar.Brand>
    );
}
